import i18n from "@/plugins/i18n";

export default function ({ globals }) {
	return {
		namespaced: true,
		state: {
			currentUserUsername: "",
			currentUserEmail: "",
			currentUserId: "",
			password: "",
			submitFormLoading: false,
		},
		mutations: {
			SET_CURRENT_USER_USERNAME(state, value) {
				state.currentUserUsername = value ? value.replace(/\s/g, "") : value;
			},
			SET_CURRENT_USER_EMAIL(state, value) {
				state.currentUserEmail = value ? value.replace(/\s/g, "") : value;
			},
			SET_CURRENT_USER_ID(state, value) {
				state.currentUserId = value ? value.replace(/\s/g, "") : value;
			},
			SET_PASSWORD(state, value) {
				state.password = value ? value.replace(/\s/g, "") : value;
			},
			SET_SUBMIT_LOADING_FORM(state, value) {
				state.submitFormLoading = value;
			},
		},
		actions: {
			async addUserPwAuthentication({ state, dispatch }) {
				try {
					const tokens = await dispatch("token/getTokens", null, { root: true });
					const globalConfig = await globals.getAsyncGlobalVariable("environmentConfig");
					const fetchSignUp = await fetch(`${globalConfig.backends.users}/users/${state.currentUserId}/authentications/form-register`, {
						method: "POST",
						headers: {
							"Content-Type": "application/json",
							...tokens,
						},
						body: JSON.stringify({
							username: state.currentUserUsername,
							password: state.password,
							email: state.currentUserEmail,
						}),
						credentials: "include",
					});

					const { result, error = null } = await fetchSignUp.json();

					if (error) throw new Error(error.code);

					const { sub } = result;

					if (sub) {
						dispatch("postMessageSendAccountInfo", {
							type: "cognito-sub",
							sub,
						});
						return;
					}
				} catch (error) {
					const translationExists = i18n.te(`authSwitchFormRegisterComponent.errorMessages.${error.message}`);
					const code = translationExists ? error.message : "networkError";
					dispatch("logger/logError", {
						id: Date.now(),
						handled: true,
						code,
						source: "backend",
						stack: error,
						notification: i18n.t(`authSwitchFormRegisterComponent.errorMessages.${code}`),
						target: {
							uid: "authSwitchFormRegistration",
							type: "flagToast",
						},
					}, { root: true });
				}
			},
			async postMessageSendAccountInfo(context, data) {
				const globalConfig = await globals.getAsyncGlobalVariable("environmentConfig");
				console.log(globalConfig);
				const spaUrl = globalConfig.pluginUrlTemplates.chamaileonSpa.replace("/openChamaileonSpa.js", "");
				window.opener.postMessage(JSON.stringify(data), spaUrl);
			},
		},
	};
}
